// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ControlCaja_container__FIkU8 {
  width: 100%;
  font-size: 16px;
  display: flex;
  justify-content: center;
}

.ControlCaja_container__FIkU8 .ControlCaja_title__pJ8UU {
  width: 100%;
  height: 10%;
  display: flex;
  margin-top: 45px;
  margin-left: 30px;
  justify-content: flex-start;
  align-items: center;
}

.ControlCaja_container__FIkU8 .ControlCaja_title__pJ8UU .ControlCaja_icon__tRcid {
  margin-left: 10px;
  width: 40px;
  height: 40px;
}
.ControlCaja_container__FIkU8 .ControlCaja_headerLogo__6NXng {
  margin-left: 30px;
  width: 15rem;
  max-height: 20rem;
  object-fit: contain;
}

.ControlCaja_container__FIkU8 .ControlCaja_title__pJ8UU h2 {
  font-family: Roboto, sans-serif;
  font-weight: 300;
  width: 30%;
  margin-left: 10px;
  font-size: 2em;
}

.ControlCaja_container__FIkU8 .ControlCaja_content__tFnds {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 90%;
}

.ControlCaja_container__FIkU8 .ControlCaja_content__tFnds .ControlCaja_options__toPBT {
  margin-top: 20px;
  width: 100%;
  height: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ControlCaja_filters__iMKu6 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.ControlCaja_filterButton__6FI8v {
  animation: ControlCaja_init3__rBTwd 0.5s both;
  height: 3rem;
  width: 10rem;
  margin-left: 5px;
  margin-bottom: 10px;
  border-radius: 5px;
}

.ControlCaja_filterButton__6FI8v p {
  text-transform: capitalize;
  margin-left: 5px;
  font-weight: 400;
}

.ControlCaja_container__FIkU8 .ControlCaja_content__tFnds .ControlCaja_options__toPBT .ControlCaja_filters__iMKu6 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.ControlCaja_date__nBeYH {
  scale: 1;
  width: 100%;
  text-align: start;
}

.ControlCaja_container__FIkU8 .ControlCaja_content__tFnds .ControlCaja_options__toPBT .ControlCaja_filters__iMKu6 .ControlCaja_datePickers__LM9mC {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.ControlCaja_container__FIkU8 .ControlCaja_content__tFnds .ControlCaja_options__toPBT .ControlCaja_filters__iMKu6 .ControlCaja_datePickers__LM9mC p {
  width: 100%;
  font-size: 1.2em;
  margin: 0;
  margin-left: 25px;
  margin-bottom: 10px;
}

.ControlCaja_container__FIkU8 .ControlCaja_content__tFnds .ControlCaja_options__toPBT .ControlCaja_filters__iMKu6 .ControlCaja_datePickers__LM9mC .ControlCaja_date__nBeYH {
  scale: 0.8;
}

.ControlCaja_container__FIkU8 .ControlCaja_content__tFnds .ControlCaja_options__toPBT .ControlCaja_filters__iMKu6 .ControlCaja_gameSelector__ImVtR {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ControlCaja_container__FIkU8 .ControlCaja_content__tFnds .ControlCaja_options__toPBT .ControlCaja_filters__iMKu6 .ControlCaja_gameSelector__ImVtR p {
  width: 100%;
  font-size: 1.2em;
  margin: 0;
  margin-left: 25px;
  margin-bottom: 10px;
}

.ControlCaja_container__FIkU8 .ControlCaja_content__tFnds .ControlCaja_options__toPBT .ControlCaja_filters__iMKu6 .ControlCaja_gameSelector__ImVtR .ControlCaja_selector__UChcy {
  width: 100%;
  scale: 0.8;
}

.ControlCaja_container__FIkU8 .ControlCaja_content__tFnds .ControlCaja_options__toPBT .ControlCaja_printOptions__RzZip {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.ControlCaja_container__FIkU8 .ControlCaja_content__tFnds .ControlCaja_options__toPBT .ControlCaja_printOptions__RzZip .ControlCaja_item__3hd1M {
  transition: 0.3s;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  margin-inline: 15px;
}

.ControlCaja_container__FIkU8 .ControlCaja_content__tFnds .ControlCaja_options__toPBT .ControlCaja_printOptions__RzZip .ControlCaja_item__3hd1M:hover {
  transition: 0.5s;
  scale: 1.05;
  cursor: pointer;
  filter: brightness(0.4);
}

.ControlCaja_container__FIkU8 .ControlCaja_content__tFnds .ControlCaja_options__toPBT .ControlCaja_printOptions__RzZip .ControlCaja_item__3hd1M .ControlCaja_icons__LFU0O {
  font-size: 32px;
}

.ControlCaja_container__FIkU8 .ControlCaja_content__tFnds .ControlCaja_options__toPBT .ControlCaja_printOptions__RzZip .ControlCaja_item__3hd1M p {
  font-size: 0.8em;
  text-align: center;
  margin: 0;
  margin-top: 5px;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.ControlCaja_container__FIkU8 .ControlCaja_infoContainer__JeiCq .ControlCaja_tableContainer__xbqhe {
  border-radius: 5px;
  margin-bottom: 30px;
  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.198);
}

.ControlCaja_container__FIkU8 .ControlCaja_content__tFnds .ControlCaja_noAgencieSelected__9Qvse {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.ControlCaja_container__FIkU8 .ControlCaja_content__tFnds .ControlCaja_noAgencieSelected__9Qvse h3 {
  font-size: 32px;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-top: 10%;
}

.ControlCaja_container__FIkU8 .ControlCaja_content__tFnds .ControlCaja_noAgencieSelected__9Qvse .ControlCaja_redirectBtn__wqZh9 {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  width: 20%;
  border-radius: 10px;
  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.298);
}

.ControlCaja_container__FIkU8 .ControlCaja_content__tFnds .ControlCaja_noAgencieSelected__9Qvse .ControlCaja_redirectBtn__wqZh9:hover {
  transition: 0.3s;
  cursor: pointer;
  scale: 1.06;
  filter: brightness(1.3);
  box-shadow: 0px 0px 15px -3px rgba(255, 255, 255, 0.298);
}

.ControlCaja_container__FIkU8 .ControlCaja_noResults__VU-Io {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 32px;
  font-weight: 300;
  height: 300px;
}

.ControlCaja_container__FIkU8 .ControlCaja_header__dR7EM .ControlCaja_titleContainer__M7a3l .ControlCaja_add_btn__ZBYD- {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45px;
  width: 100px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 300;
  font-family: Roboto, sans-serif;
  margin-left: 10px;
}

.ControlCaja_container__FIkU8 .ControlCaja_header__dR7EM .ControlCaja_titleContainer__M7a3l .ControlCaja_add_btn__ZBYD-:hover {
  transition: 0.3s;
  scale: 1.03;
  filter: brightness(1.2);
  cursor: pointer;
  border-radius: 5px;
}

.ControlCaja_insertPaginate__7jlJo {
  width: 30px;
  height: 30px;
}

.ControlCaja_insertPaginateButton__8kYjF {
  width: 30px;
  height: 30px;
}

.ControlCaja_container__FIkU8 .ControlCaja_header__dR7EM .ControlCaja_titleContainer__M7a3l {
  animation: ControlCaja_init2__vPXQZ 0.5s both;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.ControlCaja_container__FIkU8 .ControlCaja_header__dR7EM .ControlCaja_titleContainer__M7a3l h4 {
  font-size: 1.5rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-left: 10px;
}

/*---Tabs---*/
.ControlCaja_container__FIkU8 .ControlCaja_tabContainer__zWTBX {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  max-height: 47px;
}

.ControlCaja_container__FIkU8 .ControlCaja_tabContainer__zWTBX .ControlCaja_tabs__XI5G6 .MuiTabs-indicator {
  display: none;
}

.ControlCaja_container__FIkU8 .ControlCaja_tabContainer__zWTBX .ControlCaja_tabs__XI5G6 .ControlCaja_tabItem__6u74A {
  border: 1px solid #e9e9e9;
  background: #f7f7f7;
  font-size: 0.7em;
  border-radius: 15px 15px 0 0;
  margin-left: 5px;
  text-transform: capitalize;
}

.ControlCaja_container__FIkU8 .ControlCaja_tabContainer__zWTBX .ControlCaja_tabs__XI5G6 .ControlCaja_selected__4\\+VFe {
  transition-delay: 0.2s;
  border-bottom-width: 0;
  background-color: #ffffff;
}

/*---Información---*/
.ControlCaja_container__FIkU8 .ControlCaja_infoContainer__JeiCq {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 300px;
  margin-bottom: 20px;
}
.ControlCaja_container__FIkU8 .ControlCaja_infoContainer__JeiCq .ControlCaja_tableContainer__xbqhe {
  margin-top: 20px;
  max-height: 70vh;
  overflow-y: scroll;
  border-radius: 5px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.ControlCaja_container__FIkU8 .ControlCaja_dataContainer__ghn7J .ControlCaja_tableContainer__xbqhe .ControlCaja_iconbtn__QnL0n {
  transition: 0.3s;
  font-size: 30px;
}

.ControlCaja_container__FIkU8 .ControlCaja_dataContainer__ghn7J .ControlCaja_tableContainer__xbqhe .ControlCaja_iconbtn__QnL0n:hover {
  transition: 0.3s;
  cursor: pointer;
  filter: brightness(0.7);
  scale: 1.1;
}

.ControlCaja_container__FIkU8 .ControlCaja_selectAgency__rViZo {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ControlCaja_iconOptions__tMNOl {
  transition: 0.3s;
}

.ControlCaja_iconOptions__tMNOl:hover {
  scale: 1.03;
  filter: brightness(0.6);
  transition: 0.3s;
  cursor: pointer;
}

.ControlCaja_container__FIkU8 .ControlCaja_filters__iMKu6 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

@keyframes ControlCaja_init__bptWY {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes ControlCaja_init2__vPXQZ {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}

@keyframes ControlCaja_init3__rBTwd {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}

@media screen and (max-width: 500px) {
  .ControlCaja_container__FIkU8 .ControlCaja_header__dR7EM .ControlCaja_titleContainer__M7a3l .ControlCaja_add_btn__ZBYD- {
    width: 80px;
    height: 40px;
  }
  .ControlCaja_container__FIkU8 .ControlCaja_header__dR7EM .ControlCaja_titleContainer__M7a3l h4 {
    font-size: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/ControlCaja/ControlCaja.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,6CAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,QAAQ;EACR,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6CAA0B;EAC1B,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".container {\n  width: 100%;\n  font-size: 16px;\n  display: flex;\n  justify-content: center;\n}\n\n.container .title {\n  width: 100%;\n  height: 10%;\n  display: flex;\n  margin-top: 45px;\n  margin-left: 30px;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .title .icon {\n  margin-left: 10px;\n  width: 40px;\n  height: 40px;\n}\n.container .headerLogo {\n  margin-left: 30px;\n  width: 15rem;\n  max-height: 20rem;\n  object-fit: contain;\n}\n\n.container .title h2 {\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  width: 30%;\n  margin-left: 10px;\n  font-size: 2em;\n}\n\n.container .content {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  height: 90%;\n}\n\n.container .content .options {\n  margin-top: 20px;\n  width: 100%;\n  height: 20%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.filters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.filterButton {\n  animation: init3 0.5s both;\n  height: 3rem;\n  width: 10rem;\n  margin-left: 5px;\n  margin-bottom: 10px;\n  border-radius: 5px;\n}\n\n.filterButton p {\n  text-transform: capitalize;\n  margin-left: 5px;\n  font-weight: 400;\n}\n\n.container .content .options .filters {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n.date {\n  scale: 1;\n  width: 100%;\n  text-align: start;\n}\n\n.container .content .options .filters .datePickers {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.container .content .options .filters .datePickers p {\n  width: 100%;\n  font-size: 1.2em;\n  margin: 0;\n  margin-left: 25px;\n  margin-bottom: 10px;\n}\n\n.container .content .options .filters .datePickers .date {\n  scale: 0.8;\n}\n\n.container .content .options .filters .gameSelector {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .content .options .filters .gameSelector p {\n  width: 100%;\n  font-size: 1.2em;\n  margin: 0;\n  margin-left: 25px;\n  margin-bottom: 10px;\n}\n\n.container .content .options .filters .gameSelector .selector {\n  width: 100%;\n  scale: 0.8;\n}\n\n.container .content .options .printOptions {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n}\n\n.container .content .options .printOptions .item {\n  transition: 0.3s;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n  margin-inline: 15px;\n}\n\n.container .content .options .printOptions .item:hover {\n  transition: 0.5s;\n  scale: 1.05;\n  cursor: pointer;\n  filter: brightness(0.4);\n}\n\n.container .content .options .printOptions .item .icons {\n  font-size: 32px;\n}\n\n.container .content .options .printOptions .item p {\n  font-size: 0.8em;\n  text-align: center;\n  margin: 0;\n  margin-top: 5px;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.container .infoContainer .tableContainer {\n  border-radius: 5px;\n  margin-bottom: 30px;\n  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.198);\n}\n\n.container .content .noAgencieSelected {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .content .noAgencieSelected h3 {\n  font-size: 32px;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-top: 10%;\n}\n\n.container .content .noAgencieSelected .redirectBtn {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n  width: 20%;\n  border-radius: 10px;\n  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.298);\n}\n\n.container .content .noAgencieSelected .redirectBtn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  scale: 1.06;\n  filter: brightness(1.3);\n  box-shadow: 0px 0px 15px -3px rgba(255, 255, 255, 0.298);\n}\n\n.container .noResults {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 32px;\n  font-weight: 300;\n  height: 300px;\n}\n\n.container .header .titleContainer .add_btn {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 45px;\n  width: 100px;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n  margin-left: 10px;\n}\n\n.container .header .titleContainer .add_btn:hover {\n  transition: 0.3s;\n  scale: 1.03;\n  filter: brightness(1.2);\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.insertPaginate {\n  width: 30px;\n  height: 30px;\n}\n\n.insertPaginateButton {\n  width: 30px;\n  height: 30px;\n}\n\n.container .header .titleContainer {\n  animation: init2 0.5s both;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  font-size: 1.5rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-left: 10px;\n}\n\n/*---Tabs---*/\n.container .tabContainer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  max-height: 47px;\n}\n\n.container .tabContainer .tabs :global .MuiTabs-indicator {\n  display: none;\n}\n\n.container .tabContainer .tabs .tabItem {\n  border: 1px solid #e9e9e9;\n  background: #f7f7f7;\n  font-size: 0.7em;\n  border-radius: 15px 15px 0 0;\n  margin-left: 5px;\n  text-transform: capitalize;\n}\n\n.container .tabContainer .tabs .selected {\n  transition-delay: 0.2s;\n  border-bottom-width: 0;\n  background-color: #ffffff;\n}\n\n/*---Información---*/\n.container .infoContainer {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  min-height: 300px;\n  margin-bottom: 20px;\n}\n.container .infoContainer .tableContainer {\n  margin-top: 20px;\n  max-height: 70vh;\n  overflow-y: scroll;\n  border-radius: 5px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .dataContainer .tableContainer .iconbtn {\n  transition: 0.3s;\n  font-size: 30px;\n}\n\n.container .dataContainer .tableContainer .iconbtn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  filter: brightness(0.7);\n  scale: 1.1;\n}\n\n.container .selectAgency {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.iconOptions {\n  transition: 0.3s;\n}\n\n.iconOptions:hover {\n  scale: 1.03;\n  filter: brightness(0.6);\n  transition: 0.3s;\n  cursor: pointer;\n}\n\n.container .filters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes init2 {\n  0% {\n    opacity: 0;\n    transform: translateX(-100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n}\n\n@keyframes init3 {\n  0% {\n    opacity: 0;\n    transform: translateX(100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .container .header .titleContainer .add_btn {\n    width: 80px;\n    height: 40px;\n  }\n  .container .header .titleContainer h4 {\n    font-size: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ControlCaja_container__FIkU8`,
	"title": `ControlCaja_title__pJ8UU`,
	"icon": `ControlCaja_icon__tRcid`,
	"headerLogo": `ControlCaja_headerLogo__6NXng`,
	"content": `ControlCaja_content__tFnds`,
	"options": `ControlCaja_options__toPBT`,
	"filters": `ControlCaja_filters__iMKu6`,
	"filterButton": `ControlCaja_filterButton__6FI8v`,
	"init3": `ControlCaja_init3__rBTwd`,
	"date": `ControlCaja_date__nBeYH`,
	"datePickers": `ControlCaja_datePickers__LM9mC`,
	"gameSelector": `ControlCaja_gameSelector__ImVtR`,
	"selector": `ControlCaja_selector__UChcy`,
	"printOptions": `ControlCaja_printOptions__RzZip`,
	"item": `ControlCaja_item__3hd1M`,
	"icons": `ControlCaja_icons__LFU0O`,
	"infoContainer": `ControlCaja_infoContainer__JeiCq`,
	"tableContainer": `ControlCaja_tableContainer__xbqhe`,
	"noAgencieSelected": `ControlCaja_noAgencieSelected__9Qvse`,
	"redirectBtn": `ControlCaja_redirectBtn__wqZh9`,
	"noResults": `ControlCaja_noResults__VU-Io`,
	"header": `ControlCaja_header__dR7EM`,
	"titleContainer": `ControlCaja_titleContainer__M7a3l`,
	"add_btn": `ControlCaja_add_btn__ZBYD-`,
	"insertPaginate": `ControlCaja_insertPaginate__7jlJo`,
	"insertPaginateButton": `ControlCaja_insertPaginateButton__8kYjF`,
	"init2": `ControlCaja_init2__vPXQZ`,
	"tabContainer": `ControlCaja_tabContainer__zWTBX`,
	"tabs": `ControlCaja_tabs__XI5G6`,
	"tabItem": `ControlCaja_tabItem__6u74A`,
	"selected": `ControlCaja_selected__4+VFe`,
	"dataContainer": `ControlCaja_dataContainer__ghn7J`,
	"iconbtn": `ControlCaja_iconbtn__QnL0n`,
	"selectAgency": `ControlCaja_selectAgency__rViZo`,
	"iconOptions": `ControlCaja_iconOptions__tMNOl`,
	"init": `ControlCaja_init__bptWY`
};
export default ___CSS_LOADER_EXPORT___;
